import {
  getRegPath,
  SPIKES,
  SPIKES_2,
  SPIKES_3,
  SPIKES_4,
  SPIKES_5,
  SPIKES_6,
  SPIKES_7,
} from "../constants";

const candidateSignInSteps = [
  { percent: 100, imgPath: SPIKES },
  { percent: 10, imgPath: SPIKES_2 },
  { percent: 10, imgPath: SPIKES_3 },
  { percent: 10, imgPath: SPIKES_4 },
  { percent: 10, imgPath: SPIKES_5 },
  { percent: 10, imgPath: SPIKES_6 },
  { percent: 10, imgPath: SPIKES_7 },
];

const progressStep = steps => (index, percent) => {
  const clonedSteps = [...steps].map((el, ind) =>
    ind < index ? { ...el, percent: 100 } : { ...el }
  );
  clonedSteps[index].percent = percent;
  return clonedSteps;
};

const progressCandStep = progressStep(candidateSignInSteps);

export const stepRoutesMapping = {
  [getRegPath("/step3/1")]: progressCandStep(0, 100), // [20, 0, 0, 0]
  [getRegPath("/step3/2")]: progressCandStep(1, 100), // [20, 0, 0, 0]
  [getRegPath("/step3/3")]: progressCandStep(2, 100), // [20, 0, 0, 0]
  [getRegPath("/step3/4")]: progressCandStep(3, 100), // [20, 0, 0, 0]
  [getRegPath("/step3/5")]: progressCandStep(4, 100), // [20, 0, 0, 0]
  [getRegPath("/step3/6")]: progressCandStep(5, 100), // [20, 0, 0, 0]
  [getRegPath("/step3/7")]: progressCandStep(6, 100), // [20, 0, 0, 0]
};
